export default __webpack_public_path__ + "static/media/success.53cacc6d.png";